import { KeyboardEvent } from "react";

const ACTIVATION_KEYS = ["Enter", " ", "Spacebar"] as const;

/**
 * Keyboard activation handler for elements that use `role="button"` and an
 * `onClick` handler but cannot be a native `<button>` (table cells, rows,
 * large clickable containers). Fires `handler` on Enter / Space so the element
 * is operable via keyboard, satisfying WCAG 2.1 keyboard requirements.
 *
 * Prefer a native `<button>` whenever the markup allows it; use this only when
 * converting to a button would break layout/semantics.
 */
export const onActivateKeyDown =
  <T extends Element>(handler: (event: KeyboardEvent<T>) => void) =>
  (event: KeyboardEvent<T>): void => {
    if (
      !ACTIVATION_KEYS.includes(event.key as (typeof ACTIVATION_KEYS)[number])
    ) {
      return;
    }

    // Space scrolls the page by default; prevent it when used as activation.
    event.preventDefault();
    handler(event);
  };
